import React from 'react';

function Row({ label, value }) {
  return (
    <div className="ob-review-row">
      <span className="ob-review-row-label">{label}</span>
      <span className="ob-review-row-value">{value || '—'}</span>
    </div>
  );
}

export default function StepReview({ antworten = {} }) {
  const name       = antworten.name;
  const stammdaten = antworten.stammdaten;
  const stelle     = antworten.stelle;

  const fullName = [stammdaten?.vorname || name?.vorname, stammdaten?.nachname || name?.nachname]
    .filter(Boolean).join(' ') || '—';

  const stelleQuelle = stelle?.job?.type === 'link'
    ? stelle.job.url || stelle.inhalt || '—'
    : stelle?.job?.type === 'text'
    ? 'Text eingefügt'
    : stelle?.job?.type === 'pdf'
    ? stelle.job.pdf?.name || 'PDF'
    : stelle?.inhalt || '—';

  const vorlagenLabel = { cv_standard: 'Standard', cv_modern: 'Modern', cv_professionell: 'Professionell' };
  const vorlage = vorlagenLabel[stelle?.job?.cvVorlage] || stelle?.job?.cvVorlage || '—';

  return (
    <div className="ob-step-enter ob-review">
      <div className="ob-review-card">
        <span className="ob-review-card-label">DEINE ANGABEN</span>

        <Row label="Name"   value={fullName} />
        {stammdaten?.email && <Row label="E-Mail" value={stammdaten.email} />}
        {stammdaten?.ort   && <Row label="Ort"    value={stammdaten.ort} />}

        <div className="ob-review-divider" />

        <Row label="Stelle"  value={stelleQuelle} />
        <Row label="Vorlage" value={vorlage} />

        {stammdaten?.cvDatei && (
          <>
            <div className="ob-review-divider" />
            <div className="ob-review-row">
              <span className="ob-review-row-label">Lebenslauf</span>
              <span className="ob-review-cv-badge">✓  {stammdaten.cvDatei.name}</span>
            </div>
          </>
        )}
      </div>

      <p className="ob-review-hint">Alles korrekt? Dann geht's weiter zum letzten Schritt.</p>
    </div>
  );
}
